import { Base } from "../../framework/base";
import { DatabaseRecordType } from "../enums";

export interface ICalendarTaskCategoryListItem {
    id: string;
    companyId: string;
    databaseRecordType: DatabaseRecordType;
    code: string;
    color: string;
    comment: string;
    sortOrder: number;
    activeState: number;

    isRemovable: boolean;
    getHash(): string;
}

export class CalendarTaskCategoryListItem implements ICalendarTaskCategoryListItem {
    id: string;
    companyId: string;
    databaseRecordType: DatabaseRecordType;
    code: string;
    color: string;
    comment: string;
    sortOrder: number;
    activeState: number;

    isRemovable: boolean;

    constructor();
    constructor(obj: ICalendarTaskCategoryListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.databaseRecordType = obj?.databaseRecordType;
        this.code = obj && obj.code || "";
        this.color = obj && obj.color || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.activeState = obj && obj.activeState || 0;
        this.isRemovable = Base.isNullOrUndefined(this.databaseRecordType);
    }

    getHash(): string {
        return this.id + "#" + this.code + "#" + this.color + "#" + this.activeState.toString(10);
    }
}